module.exports = __webpack_public_path__ + "static/assets/3849ce2a76855b17413da53f925f62d7.svg";